import { Container } from '@chakra-ui/react';
const CUIContainer = Container;
export default CUIContainer;